<template>
  <div class="container mt-2">
    <div class="card shadow">
      <div class="card-body">
        <form @submit.prevent="guardarPlantillaRuta">
          <div class="row g-3">
            <div class="col-md-6">
              <label for="plantillaRuta.codigoSN" class="form-label">
                <span class="text-danger fw-bold">Paso 1</span> - NIT
              </label>
              <input v-model="plantillaRuta.codigoSN" type="text" id="plantillaRuta.codigoSN" class="form-control" />
            </div>
            <div class="col-md-6">
              <label for="plantillaRuta.nombreCliente" class="form-label">
                <span class="text-danger fw-bold">Paso 2</span> - Nombre Cliente
              </label>
              <input v-model="plantillaRuta.nombreCliente" type="text" id="plantillaRuta.nombreCliente"
                class="form-control" :class="{ 'is-invalid': !plantillaRuta.nombreCliente }" required />
              <div class="invalid-feedback font-weight-bold">El nombre del cliente es requerido.</div>
            </div>
            <div class="col-md-6">
              <label for="lugarEntrega" class="form-label">
                <span class="text-danger fw-bold">Paso 4</span> - Centro de Costo
              </label>
              <input v-model="plantillaRuta.lugarEntrega" type="text" id="lugarEntrega" class="form-control"
                :class="{ 'is-invalid': !plantillaRuta.lugarEntrega }" required />
              <div class="invalid-feedback font-weight-bold">El centro de costo es requerido.</div>
            </div>
            <div class="col-md-6">
              <label for="direccionPuntoEntrega" class="form-label">
                <span class="text-danger fw-bold">Paso 5</span> - Dirección entrega
              </label>
              <input v-model="plantillaRuta.direccionPuntoEntrega" type="text" id="direccionPuntoEntrega"
                class="form-control" />
            </div>
            <div class="col-md-6">
              <label for="latUbicacionEntrega" class="form-label">
                <span class="text-danger fw-bold">Paso 6</span> - Latitud
              </label>
              <input v-model="plantillaRuta.latUbicacionEntrega" type="text" step="any" id="latUbicacionEntrega"
                class="form-control" :class="{
                  'is-invalid': !plantillaRuta.latUbicacionEntrega || !isValidLatitude(plantillaRuta.latUbicacionEntrega)
                }" required />
              <div class="invalid-feedback font-weight-bold">
                {{ !plantillaRuta.latUbicacionEntrega ? 'La latitud es requerida.' :
                  'La latitud debe estar entre -90 y 90 grados.' }}
              </div>
            </div>
            <div class="col-md-6">
              <label for="longUbicacionEntrega" class="form-label">
                <span class="text-danger fw-bold">Paso 7</span> - Longitud
              </label>
              <input v-model="plantillaRuta.longUbicacionEntrega" type="text" step="any" id="longUbicacionEntrega"
                class="form-control" :class="{
                  'is-invalid': !plantillaRuta.longUbicacionEntrega || !isValidLongitude(plantillaRuta.longUbicacionEntrega)
                }" required />
              <div class="invalid-feedback font-weight-bold">
                {{ !plantillaRuta.longUbicacionEntrega ? 'La longitud es requerida.' :
                  'La longitud debe estar entre - 180 y 180 grados.' }}
              </div>
            </div>
            <div class="col-md-6">
              <label for="plantillaRuta.nombrePersonaCliente" class="form-label">
                <span class="text-danger fw-bold">Paso 8</span> - Nombre Contacto Cliente
              </label>
              <input v-model="plantillaRuta.nombrePersonaCliente" type="text" id="plantillaRuta.nombrePersonaCliente"
                class="form-control" :class="{ 'is-invalid': !plantillaRuta.nombrePersonaCliente }" required />
              <div class="invalid-feedback font-weight-bold">El nombre de contacto es requerido.</div>
            </div>
            <div class="col-md-6">
              <label for="plantillaRuta.contactoPersonaCliente" class="form-label">
                <span class="text-danger fw-bold">Paso 9</span> - Número Telefónico Contacto Cliente
              </label>
              <input v-model="plantillaRuta.contactoPersonaCliente" type="tel" id="plantillaRuta.contactoPersonaCliente"
                class="form-control" required pattern="[0-9]{10}"
                :class="{ 'is-invalid': !plantillaRuta.contactoPersonaCliente }" />
              <small class="form-text text-muted">Formato: 1234567890 (10 dígitos)</small>
              <div class="invalid-feedback font-weight-bold ">El número de contacto es requerido.</div>
            </div>
            <div class="col-12">
              <label for="ubicacion" class="form-label">
                <span class="text-danger fw-bold">Paso 10</span> - Zona
              </label>
              <input v-model="ubicacion" type="text" id="ubicacion" class="form-control" />
            </div>
          </div>
          <div class="d-flex justify-content-end mt-4">
            <vs-button :loading="isCreating" type="submit" animation-type="vertical" class="btn btn-primary"
              :disabled=!formValido>
              Guardar Plantilla de Ruta
              <template #animate><i class="fas fa-plus-circle"></i></template>
            </vs-button>
          </div>
        </form>
      </div>
    </div>

    <CargaMasivaPlantillas :plantillasDisponibles="plantillasRutasKeys" :puntosEntregaExistentes="plantillaRutasExistentes" @obtenerPlantillasActualizadas='getPuntosEntregaData()'  />

    <DataTableButtons :items="plantillasRutas" :headers="headerPlantillaPuntosEntrega" :keys="plantillasRutasKeys"
      :actions1="showNotaAnexo" button1="fa-solid fa-pen" titleButton1="Editar punto de entrega"
      tableId="datatable_PlantillaRutaModal" class="mt-2 w-100 h-100" />
    <b-modal v-model="showModal" title="Editar Plantilla" size="lg" hide-footer id="modalPlantillaPuntoEntregaEditar">
      <form @submit.prevent="actualizarPlantillaRuta(modalData.id)" class="py-4 px-2">
        <div class="row">
          <div class="col-md-6">
            <label for="codigoSN" class="form-label">NIT</label>
            <input v-model="modalData.codigoSN" type="text" id="codigoSN" class="form-control" />
          </div>

          <div class="col-md-6">
            <label for="nombreCliente" class="form-label">Nombre Cliente</label>
            <input v-model="modalData.nombreCliente" type="text" id="nombreCliente" class="form-control"
              :class="{ 'is-invalid': !modalData.nombreCliente }" required />
            <div class="invalid-feedback font-weight-bold">El nombre del cliente es requerido.</div>
          </div>

          <div class="col-md-6">
            <label for="lugarEntrega" class="form-label">Centro de Costo</label>
            <input v-model="modalData.lugarEntrega" type="text" id="lugarEntrega" class="form-control"
              :class="{ 'is-invalid': !modalData.lugarEntrega }" required />
            <div class="invalid-feedback font-weight-bold">El centro de costo es requerido.</div>
          </div>

          <div class="col-md-6">
            <label for="direccionPuntoEntrega" class="form-label">Dirección Entrega</label>
            <input v-model="modalData.direccionPuntoEntrega" type="text" id="direccionPuntoEntrega"
              class="form-control" />
          </div>

          <div class="col-md-6">
            <label for="latitudModal" class="form-label">Latitud</label>
            <input v-model="modalData.latUbicacionEntrega" type="text" step="any" id="latitudModal" class="form-control"
              :class="{
                'is-invalid': !modalData.latUbicacionEntrega || !isValidLatitude(modalData.latUbicacionEntrega)
              }" required />
            <div class="invalid-feedback font-weight-bold">
              {{ !modalData.latUbicacionEntrega ? 'La latitud es requerida.' :
                'La latitud debe estar entre -90 y 90 grados.' }}
            </div>
          </div>

          <div class="col-md-6">
            <label for="longitudModal" class="form-label">Longitud</label>
            <input v-model="modalData.longUbicacionEntrega" type="text" step="any" id="longitudModal"
              class="form-control" :class="{
                'is-invalid': !modalData.longUbicacionEntrega || !isValidLongitude(modalData.longUbicacionEntrega)
              }" required />
            <div class="invalid-feedback font-weight-bold">
              {{ !modalData.longUbicacionEntrega ? 'La longitud es requerida.' :
                'La longitud debe estar entre -180 y 180 grados.' }}
            </div>
          </div>

          <div class="col-md-6">
            <label for="nombrePersonaCliente" class="form-label">Nombre Contacto Cliente</label>
            <input v-model="modalData.nombrePersonaCliente" type="text" id="nombrePersonaCliente" class="form-control"
              :class="{ 'is-invalid': !modalData.nombrePersonaCliente }" required />
            <div class="invalid-feedback font-weight-bold">El nombre de contacto es requerido.</div>
          </div>

          <div class="col-md-6">
            <label for="contactoPersonaCliente" class="form-label">Número Telefónico Contacto Cliente</label>
            <input v-model="modalData.contactoPersonaCliente" type="tel" id="contactoPersonaCliente"
              class="form-control" required pattern="[0-9]{10}"
              :class="{ 'is-invalid': !modalData.contactoPersonaCliente }" />
            <small class="form-text text-muted">Formato: 1234567890 (10 dígitos)</small>
            <div class="invalid-feedback font-weight-bold">El número de contacto es requerido.</div>
          </div>

          <div class="col-12">
            <label for="ubicacion" class="form-label">Zona</label>
            <input v-model="modalData.ubicacion" type="text" id="ubicacion" class="form-control" />
          </div>
        </div>

        <div class="d-flex justify-content-end mt-4">
          <vs-button type="submit" class="btn btn-primary" :disabled="!formValidoEdit">
            Actualizar Plantilla
            <template #animate><i class="fas fa-save"></i></template>
          </vs-button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import DataTableButtons from "../../../components/Datatable/DatatableButtons.vue";

import CargaMasivaPlantillas from "./CargaMasiva/CargaMasivaPlantillas.vue";

export default {
  name: "PlantillaRutaModal",
  components: {
    DataTableButtons,
    CargaMasivaPlantillas
  },
  data() {
    return {
      isCreating: false,
      formSubmitted: false,
      ubicacion: "",
      plantillaRuta: {
        lugarEntrega: "",
        latUbicacionEntrega: null,
        longUbicacionEntrega: null,
        empresaId: null,
        estado: "1",
        ubicacion: "",
        nombreCliente: "",
        direccionPuntoEntrega: "",
        codigoSN: "",
        nombrePersonaCliente: "",
        contactoPersonaCliente: "",
      },
      plantillasRutas: [],
      headerPlantillaPuntosEntrega: [
        "NIT",
        "Nombre Cliente",
        "Centro Costos",
        "Dirección Entrega",
        "Latitud",
        "Longitud",
        "Nombre Contacto Cliente",
        "Número Telefónico Contacto Cliente",
        "Zona",
      ],
      plantillasRutasKeys: [
        "codigoSN",
        "nombreCliente",
        "lugarEntrega",
        "direccionPuntoEntrega",
        "latUbicacionEntrega",
        "longUbicacionEntrega",
        "nombrePersonaCliente",
        "contactoPersonaCliente",
        "ubicacion",
      ],
      modalData: {
        lugarEntrega: "",
        latUbicacionEntrega: null,
        longUbicacionEntrega: null,
        empresaId: null,
        estado: "1",
        ubicacion: "",
        nombreCliente: "",
        direccionPuntoEntrega: "",
        codigoSN: "",
        nombrePersonaCliente: "",
        contactoPersonaCliente: "",
      },
      showModal: false,
      plantillaRutasExistentes: null
    };
  },
  computed: {
    capitalizedUbicacion() {
      return this.ubicacion
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    },
    capitalizedUbicacionEdit() {
      return this.modalData.ubicacion
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    },
    formValido() {
      return Object.entries(this.plantillaRuta)
        .filter(([clave]) => clave !== "estado")
        .filter(([clave]) => clave !== "ubicacion")
        .filter(([clave]) => clave !== "codigoSN")
        .filter(([clave]) => clave !== "direccionPuntoEntrega")
        .every(([clave, valor]) => {
          if (valor === null || valor === "") return false;
          if (clave === "latUbicacionEntrega" && !this.isValidLatitude(valor)) return false;
          if (clave === "longUbicacionEntrega" && !this.isValidLongitude(valor)) return false;
          return true;
        });
    },
    formValidoEdit() {
      return Object.entries(this.modalData)
        .filter(([clave]) => clave !== "estado")
        .filter(([clave]) => clave !== "ubicacion")
        .filter(([clave]) => clave !== "codigoSN")
        .filter(([clave]) => clave !== "direccionPuntoEntrega")
        .every(([clave, valor]) => {
          if (valor === null || valor === "") return false;
          if (clave === "latUbicacionEntrega" && !this.isValidLatitude(valor)) return false;
          if (clave === "longUbicacionEntrega" && !this.isValidLongitude(valor)) return false;
          return true;
        });
    },
  },
  watch: {
    capitalizedUbicacion(newValue) {
      this.plantillaRuta.ubicacion = newValue;
    },
  },
  async mounted() {
    const persona = JSON.parse(localStorage.getItem("setPersonaAct"));
    this.plantillaRuta.empresaId = persona.empresa.id;
    await this.getPuntosEntregaData();
  },
  methods: {
    // Métodos de validación para coordenadas
    isValidLatitude(lat) {
      if (lat === null || lat === "") return false;
      const latitude = parseFloat(lat);
      return !isNaN(latitude) && latitude >= -90 && latitude <= 90;
    },
    isValidLongitude(lng) {
      if (lng === null || lng === "") return false;
      const longitude = parseFloat(lng);
      return !isNaN(longitude) && longitude >= -180 && longitude <= 180;
    },

    async guardarPlantillaRuta() {
      try {
        // Validar coordenadas antes de enviar
        if (!this.isValidLatitude(this.plantillaRuta.latUbicacionEntrega) ||
          !this.isValidLongitude(this.plantillaRuta.longUbicacionEntrega)) {
          this.$vs.notification({
            progress: "auto",
            icon: `<i class='fas fa-exclamation-circle'></i>`,
            color: "danger",
            position: "top-right",
            title: "Error",
            text: "Por favor, ingrese coordenadas válidas",
          });
          return;
        }

        this.formSubmitted = true;
        this.isCreating = true;
        this.plantillaRuta.ubicacion = this.capitalizedUbicacion;
        const respuesta = await this.$store.dispatch("hl_post", {
          path: "EntregasApp/CreatePlantillaRutas",
          data: this.plantillaRuta,
        });
        if (respuesta.success) {
          this.$vs.notification({
            progress: "auto",
            icon: `<i class='fas fa-circle-check'></i>`,
            color: "success",
            position: "top-right",
            title: "Éxito",
            text: "Plantilla de ruta guardada correctamente",
          });
          await this.getPuntosEntregaData();
          this.$emit("plantilla-ruta-agregada");
          this.$bvModal.hide("modalPlantillaRuta");
          // Clear the form after successful submission
          this.resetForm();
        }
      } catch (error) {
        console.error("Error al guardar la plantilla de ruta:", error);
        this.$vs.notification({
          progress: "auto",
          icon: `<i class='fas fa-exclamation-circle'></i>`,
          color: "danger",
          position: "top-right",
          title: "Error",
          text: "No se pudo guardar la plantilla de ruta",
        });
      } finally {
        this.isCreating = false;
      }
    },
    async getPuntosEntregaData() {
      try {
        const path = `EntregasApp/GetPlantillasRutasByEmpresa/${this.plantillaRuta.empresaId}`;
        const response = await this.$store.dispatch("get", { path });
        if (response && response.data) {
          this.plantillasRutas = response.data;
          this.plantillaRutasExistentes = this.plantillasRutas.map(puntosEntrega => { return puntosEntrega.lugarEntrega})
          console.log("Los datos obtenidos de las plantillas son:", response);
        } else {
          console.error(
            "Error al obtener las plantillas de entrega. Respuesta vacía."
          );
          alert("Error al obtener las plantillas de entrega.");
        }
      } catch (error) {
        console.error("Hubo un error al hacer la solicitud:", error);
        alert("Hubo un error al obtener las plantillas de entrega.");
      }
    },
    resetForm() {
      this.ubicacion = "";
      this.plantillaRuta = {
        lugarEntrega: "",
        latUbicacionEntrega: null,
        longUbicacionEntrega: null,
        empresaId: this.plantillaRuta.empresaId,
        estado: "1",
        ubicacion: "",
        nombreCliente: "",
        direccionPuntoEntrega: "",
        codigoSN: "",
        nombrePersonaCliente: "",
        contactoPersonaCliente: "",
      };
    },
    async showNotaAnexo(itemId) {
      try {
        const path = `EntregasApp/GetPlantillasRutasById/${itemId}`;
        const response = await this.$store.dispatch("get", { path });

        if (response && response.data && response.data.length > 0) {
          this.modalData = response.data[0]; // Asegúrate de asignar el primer elemento
          this.showModal = true; // Muestra el modal
        } else {
          console.error("Datos no encontrados");
        }
      } catch (error) {
        console.error("Error al obtener los datos para el modal:", error);
      }
    },
    async actualizarPlantillaRuta(Id) {
      try {
        // Validar coordenadas antes de enviar
        if (!this.isValidLatitude(this.modalData.latUbicacionEntrega) ||
          !this.isValidLongitude(this.modalData.longUbicacionEntrega)) {
          this.$vs.notification({
            progress: "auto",
            icon: `<i class='fas fa-exclamation-circle'></i>`,
            color: "danger",
            position: "top-right",
            title: "Error",
            text: "Por favor, ingrese coordenadas válidas",
          });
          return;
        }

        this.isCreating = true;
        // Asegúrate de que la Ubicación esté correctamente capitalizada antes de enviarla
        this.modalData.ubicacion = this.capitalizedUbicacionEdit;

        // Realizar la llamada PUT usando el Vuex action 'hl_put'
        const respuesta = await this.$store.dispatch("hl_put", {
          path: `EntregasApp/UpdatePlantillaRutas/${Id}`, // Asegúrate de que la URL sea correcta
          data: this.modalData, // Los datos que se envían en la petición
        });

        // Si la respuesta es exitosa, muestra una notificación
        if (respuesta.success) {
          this.$vs.notification({
            progress: "auto",
            icon: `<i class='fas fa-circle-check'></i>`,
            color: "success",
            position: "top-right",
            title: "Éxito",
            text: "Plantilla de ruta actualizada correctamente",
          });
          await this.getPuntosEntregaData();
          this.$emit("plantilla-ruta-agregada"); // Emitir un evento para actualizar la vista
          this.cerrarModal();
          this.resetForm(); // Limpiar el formulario
        }
      } catch (error) {
        console.error("Error al actualizar la plantilla de ruta:", error);
        this.$vs.notification({
          progress: "auto",
          icon: `<i class='fas fa-exclamation-circle'></i>`,
          color: "danger",
          position: "top-right",
          title: "Error",
          text: "No se pudo actualizar la plantilla de ruta",
        });
      } finally {
        this.isCreating = false;
      }
    },
    cerrarModal() {
      // Oculta el modal y luego refresca la lista
      this.$bvModal.hide('modalPlantillaPuntoEntregaEditar');
    },
  },
};
</script>

<style scoped>
.card {
  border-radius: 15px;
}

.form-control.is-invalid {
  border-color: #ff0000 !important;
}


.form-label {
  font-weight: bold;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
}

.btn-primary:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

@import url("https://unpkg.com/vue-select@3.20.2/dist/vue-select.css");
</style>
